export const token = {
  'x-access-token': typeof window !== 'undefined' ? localStorage.getItem("x-access-token") : null,
  // 'x-access-token': localStorage.getItem("x-access-token"),
}